var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdcell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 45,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5596 66.7471H66.2275V76.1034H35.5596V66.7471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4355 35.5593H55.8314V66.747H45.4355V35.5593Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8252 69.4354L79.376 62.8715C79.0434 61.3661 77.8769 60.1873 76.3758 59.8421L70.7662 58.553C70.1798 58.4179 69.5706 58.4179 68.9843 58.553L63.3539 59.8442C61.8527 60.1893 60.6842 61.3682 60.3515 62.8736L58.9023 69.4354C58.9023 72.6748 59.9419 76.6835 62.5201 79.3698C64.2375 81.1599 66.639 82.3617 69.8721 82.3617C73.1073 82.3617 75.5088 81.1495 77.2241 79.3698C79.7856 76.7126 80.819 72.7892 80.819 69.7369C80.8252 69.6662 80.8252 69.4354 80.8252 69.4354V69.4354Z",
    fill: "#CF91A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5596 66.7471H40.2377V76.1034H35.5596V66.7471Z",
    fill: "#DCDCDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4355 35.5593H50.1136V66.747H45.4355V35.5593Z",
    fill: "#DCDCDC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2022 79.3698C64.622 76.6835 63.5845 72.6748 63.5845 69.4354L65.0337 62.8736C65.3663 61.3682 66.5348 60.1873 68.036 59.8442L72.2151 58.8857L70.7701 58.553C70.1838 58.4179 69.5746 58.4179 68.9882 58.553L63.3578 59.8442C61.8567 60.1893 60.6882 61.3682 60.3555 62.8736L58.9063 69.4354C58.9063 72.6748 59.9459 76.6835 62.5241 79.3698C64.2415 81.1599 66.6429 82.3617 69.8761 82.3617C70.7119 82.3617 71.4874 82.2744 72.2131 82.1247C70.1297 81.6943 68.4768 80.6963 67.2022 79.3698V79.3698Z",
    fill: "#9E2349"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5984 73.5066C73.7376 73.5066 73.039 72.808 73.039 71.9472C73.039 71.0864 73.7376 70.3878 74.5984 70.3878C75.4592 70.3878 76.1578 71.0885 76.1578 71.9472C76.1578 72.8059 75.4592 73.5066 74.5984 73.5066Z",
    fill: "#2F3130"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3831 73.3777C64.5598 73.3777 63.8882 72.7082 63.8882 71.8828C63.8882 71.0594 64.5577 70.3878 65.3831 70.3878C66.2086 70.3878 66.8781 71.0594 66.8781 71.8828C66.876 72.7082 66.2065 73.3777 65.3831 73.3777Z",
    fill: "#2F3130"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8783 83.921C66.5121 83.921 63.5804 82.7214 61.4014 80.4488C58.8628 77.8062 57.3491 73.6894 57.3491 69.4354C57.3491 69.3044 57.3658 69.1797 57.3928 69.0591L58.8316 62.5367C59.2932 60.4513 60.9315 58.7962 63.0086 58.3222L68.637 57.031C69.45 56.8481 70.3045 56.8481 71.1154 57.031L76.725 58.3222C78.8 58.7983 80.4363 60.4513 80.8979 62.5325L82.345 69.0986C82.37 69.2088 82.3825 69.319 82.3825 69.4333V69.7348C82.3825 72.8952 81.3242 77.3675 78.353 80.4488C76.1657 82.7214 73.2341 83.921 69.8783 83.921V83.921ZM60.4679 69.5997C60.5053 72.2839 61.3578 75.9016 63.649 78.2885C65.25 79.9581 67.3437 80.8023 69.8762 80.8023C72.4024 80.8023 74.4982 79.956 76.1054 78.2865C78.4341 75.8725 79.2637 72.286 79.2637 69.7369V69.6059L77.8519 63.2062C77.6502 62.2955 76.935 61.5699 76.0264 61.3599L70.4168 60.0708C70.0633 59.9939 69.6891 59.9918 69.3335 60.0729L63.7052 61.364C62.7945 61.5719 62.0793 62.2955 61.8776 63.2103L60.4679 69.5997Z",
    fill: "#2F3130"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8784 79.7544C68.3357 79.7544 66.8865 79.1535 65.7949 78.0599L68.0051 75.858C69.0031 76.8602 70.7538 76.8602 71.7539 75.858L73.964 78.0599C72.8704 79.1535 71.4212 79.7544 69.8784 79.7544Z",
    fill: "#2F3130"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1308 71.5708L80.8833 70.6352C80.8521 70.6144 77.1345 67.953 69.8761 67.953C62.6136 67.953 58.871 70.6164 58.8336 70.6435L57.5799 71.5541L55.7315 69.0674L56.9727 68.1401C57.1536 68.005 61.4929 64.8342 69.874 64.8342C78.2552 64.8342 82.5737 68.005 82.7525 68.1422L84 69.0778L82.1308 71.5708Z",
    fill: "#2F3130"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7918 77.6628H35.5594C34.6986 77.6628 34 76.9642 34 76.1034V66.7471C34 65.8863 34.6986 65.1877 35.5594 65.1877H52.7126V68.3065H37.1188V74.544H54.7918V77.6628Z",
    fill: "#2F3130"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9947 68.3065H43.876V35.5594C43.876 34.6986 44.5746 34 45.4354 34H55.8313C56.692 34 57.3906 34.6986 57.3906 35.5594V62.5887H54.2719V37.1188H46.9947V68.3065Z",
    fill: "#2F3130"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.277 66.7471H38.1582V41.2772C38.1582 40.4164 38.8568 39.7178 39.7176 39.7178H45.4353V42.8365H41.277V66.7471Z",
    fill: "#2F3130"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7177 45.9553H45.4355V49.0741H39.7177V45.9553Z",
    fill: "#2F3130"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7177 52.1929H45.4355V55.3117H39.7177V52.1929Z",
    fill: "#2F3130"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7177 58.4304H45.4355V61.5492H39.7177V58.4304Z",
    fill: "#2F3130"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6333 58.4304H57.3906V61.5492H50.6333V58.4304Z",
    fill: "#2F3130"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6333 52.1929H57.3906V55.3117H50.6333V52.1929Z",
    fill: "#2F3130"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6333 45.9553H57.3906V49.0741H50.6333V45.9553Z",
    fill: "#2F3130"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6333 39.7178H57.3906V42.8365H50.6333V39.7178Z",
    fill: "#2F3130"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_709",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.34902 0 0 0 0 0.764706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_709",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdcell);
export default __webpack_public_path__ + "static/media/thirdcell.9de6948a58858f9af1cb15593e2bdbe2.svg";
export { ForwardRef as ReactComponent };